import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Page({ children, className = "", ...rest }) {
    const reduced = useReducedMotion();
    return <motion.main id="main-content" tabIndex={-1} initial={{ opacity: reduced ? 1 : 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.35 }} className={className} {...rest}>{children}</motion.main>;
}

export function Reveal({ children, delay = 0, className = "", ...rest }) {
    const reduced = useReducedMotion();
    return <motion.div initial={{ opacity: reduced ? 1 : 0, y: reduced ? 0 : 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.08 }} transition={{ duration: 0.6, delay, ease: EASE }} className={className} {...rest}>{children}</motion.div>;
}

export function MaskedLine({ children, className = "" }) {
    return <span className={`block ${className}`}>{children}</span>;
}